import * as React from "react";
import EncryptUpload from './EncryptUpload';
import * as update from 'immutability-helper';

export default class Uploader extends React.Component<any, any> {

    addUpload = (value: any) => {
        const { max, onChange, value: fileList = [] } = this.props;
        const { imageId } = value;
        if (fileList.length < max) {
            const result: any = update(fileList, { $push: [imageId] });
            onChange && onChange(result);
        }
    };

    removeUpload = (index: number) => {
        const { onChange, value: fileList = [] } = this.props;
        const result: any = update(fileList, { $splice: [[index, 1]] });
        onChange && onChange(result);
    };

    render() {
        const { action, disabled, tips, hideDown, placeholder, max, value: fileList = [] } = this.props;
        return (
            (disabled && !fileList.length) ? '-' :
            <div style={{display: 'flex'}}>
                {
                    (Array.isArray(fileList) ? fileList : []).map((item: any, index: number) => {
                        return (
                            <EncryptUpload key={`${item.imageId}${index}`} action={action} disabled={disabled} hideDown={hideDown}
                                index={index}
                                previewData={item.src}
                                value={item.imageId ? item.imageId : item} placeholder={placeholder}
                                tips={tips} addUpload={this.addUpload}
                                removeUpload={this.removeUpload} />
                        );
                    })
                }
                {
                    !disabled && fileList.length < max && (
                        <EncryptUpload key={'upload'} action={action} disabled={disabled}
                            placeholder={placeholder}
                            tips={tips} addUpload={this.addUpload} />)
                }
            </div>
        );
    }
}
